import excelUrl from '../../../static/image/excel-placeholder.png'
import wordUrl from '../../../static/image/word-placeholder.png'
import rarUrl from '../../../static/image/rar-placeholder.png'
import ziplUrl from '../../../static/image/zip-placeholder.png'
import pdfUrl from '../../../static/image/pdf-placeholder.png'
import { computed, getCurrentInstance } from 'vue'
import { pgMessage } from '../../message/index'
import { http, getFileType } from '../../../utils/index'
import { ifExcel, ifImg, ifPdf, ifRar, ifWord, ifZip } from '../../file-preview/index'

export default function useUpload({ fileList, props, emit }) {
  const { proxy } = getCurrentInstance()
  const ticketId = proxy.$SsoRequest.getTicketId(proxy.$SsoRequest)
  const ssoToken = proxy.$SsoRequest.getToken(proxy.$SsoRequest)

  const actionUrl = computed(() => {
    if (props.action.indexOf('http://') != -1 || props.action.indexOf('https://') != -1) {
      return props.action
    }
    let tempAction = ''
    if (props.action == 'file/uploadFile') {
      tempAction = 'rest/file/uploadFile'
    } else {
      tempAction = props.action
    }

    return proxy.GLOBAL.baseURL + 't/' + ticketId + '/' + tempAction
  })

  const headers = computed(() => {
    return {
      'sso-token': ssoToken,
      'sso-ticket': ticketId,
    }
  })

  const onBeforeUpload = (file) => {
    if (props.format && file.type) {
      const format = getFileType(file.type.split('/')?.[1])
      if (!props.format.includes(format)) {
        pgMessage({ type: 'error', message: '上传的文件格式错误！' })
        return false
      }
    }
    if (file.size > props.maxSize) {
      const count = parseInt(props.maxSize / 1024 / 1024)
      pgMessage({ type: 'error', message: `请上传不大于${count}M的附件` })
      return false
    }
    return true
  }

  const onSuccess = (res) => {
    if (res.code === 200) {
      if (res.data?.url) {
        let resVale = [...fileList.value]
        if (props.valueIsObj) {
          props.multiple ? resVale.push(res.data) : (resVale = res.data)
        } else {
          props.multiple ? resVale.push(res.data.url) : (resVale = res.data.url)
        }
        onSubmit(resVale)
      }
    } else {
      pgMessage({ type: 'error', message: res?.msg ?? '上传失败' })
    }
  }

  const onError = (err) => {
    console.log('onError: ', err)
    console.error(err.message)
    // pgMessage({ type: 'error', message: err.message })
  }

  const onExceed = () => {
    pgMessage({ type: 'error', message: '已超过上传的限制，只允许上传 ' + props.limit + '个' })
  }

  // 支持上传后调用接口直接保存单据
  const onSubmit = async (attach) => {
    if (props.submitUrl) {
      const [res] = await http[props.submitMethod](props.submitUrl, {
        ...props.submitParam,
        attach,
      })
      if (res) {
        pgMessage.success('已保存')
        emit('input', attach)
      }
    } else {
      emit('input', attach)
    }
  }

  const remove = (file) => {
    const resVal = fileList.value.filter((item) => item.url !== file.url)
    if (props.valueIsObj) {
      props.multiple ? onSubmit(resVal) : onSubmit(null)
    } else {
      props.multiple
        ? onSubmit(
            Object.values(resVal)
              .map((im) => im.url)
              .join(',')
          )
        : onSubmit(null)
    }
  }
  const download = (file) => {
    const link = document.createElement('a')
    link.style.display = 'none'
    link.download = file?.name
    link.href = file.url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const getFileIcon = (attach) => {
    // excel
    if (ifExcel(attach)) return excelUrl
    // rar
    if (ifRar(attach)) return rarUrl
    // zip
    if (ifZip(attach)) return ziplUrl
    // word
    if (ifWord(attach)) return wordUrl
    if (ifPdf(attach)) return pdfUrl
    return ''
  }

  return {
    actionUrl,
    headers,
    onBeforeUpload,
    onSuccess,
    onError,
    onExceed,
    download,
    remove,
    getFileIcon,
    ifImg,
  }
}
